import { useEffect, useState } from 'react';
import { findStrongPackage } from '../services/discoverHint';

export const DISCOVER_HINT_MIN_CHARS = 3;
export const DISCOVER_HINT_DEBOUNCE_MS = 400;

/**
 * The Discover package that fits the name being typed (KPR-1440), or null.
 * Searches once the name settles (400 ms) and has at least 3 characters; a
 * failed search or one with no strong match is null, never an error.
 */
export default function useDiscoverHint(name, enabled = true) {
	const words = String(name || '').trim();
	const [found, setFound] = useState({ words: '', pkg: null });

	useEffect(() => {
		if (!enabled || words.length < DISCOVER_HINT_MIN_CHARS) return undefined;
		let cancelled = false;
		const controller = typeof AbortController === 'function' ? new AbortController() : null;
		const timer = setTimeout(() => {
			findStrongPackage(words, { signal: controller?.signal })
				.then((pkg) => { if (!cancelled) setFound({ words, pkg }); })
				.catch(() => { if (!cancelled) setFound({ words, pkg: null }); });
		}, DISCOVER_HINT_DEBOUNCE_MS);
		return () => { cancelled = true; clearTimeout(timer); controller?.abort(); };
	}, [words, enabled]);

	// An answer is for the words it was asked about; a name edited since shows nothing until the next answer.
	return enabled && found.words === words ? found.pkg : null;
}
